<section id="cupra__care">
    <div class="card">
        <div class="card-header">
            <h2>CUPRA Care</h2>
        </div>
        <div class="card-body">
            <div *ngIf="!model" class="loader"><img src="assets/images/loader.gif" /></div>
            <p>Tu Cupra tiene menos de <strong>37.000 km</strong> ó <strong>30 meses</strong>. Estás a tiempo de beneficiarte de la seguridad de tenerlo todo bajo control.</p>
            <p><strong>Comparativa Mantenimiento 5 años o 80.000kms</strong></p>
            <div class="row comparative">
                <div class="col-md-6">
                    <div class="box maintenance">
                        <div class="text">Coste de Mantenimiento Habitual
                        </div>
                        <div class="final__cost">
                            <div *ngIf="model">
                                <div *ngIf="model">{{model.FinalPrice | currency:'EUR'}}*</div>
                            </div>
                        </div>
                        <div class="description">*<i>Coste estimado en condiciones normales</i></div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="box cupracare">
                        <div class="text"><strong>Con</strong><br />CUPRA Care
                        </div>
                        <div class="final__cost" *ngIf="model">
                            {{model.CupraCarePrice | currency:'EUR'}}*
                        </div>
                    </div>
                </div>
            </div>
            <div class="service-link-modal">
                <a class="more-info-modal" (click)="openVerticallyCentered(content)">*SERVICIOS INCLUIDOS CUPRA CARE</a>
            </div>
        </div>
        <div class="card-footer">
            <div *ngIf="model && !model.Subscribed">
                <button type="button" (click)="contract()" class="btn btn-primary w-100">Contratar</button>
            </div>
            <div *ngIf="model && model.Subscribed">
                <h5 *ngIf="model" class="btn btn-primary w-100">Ya has contratado Cupra Care</h5>
            </div>
        </div>
    </div>
</section>

<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title">SERVICIOS INCLUIDOS CON CUPRA CARE</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <ngb-accordion [closeOthers]="true" id="select__cupra">
            <ngb-panel>
                <ng-template ngbPanelTitle>
                    <h5>CUPRA CARE (<strong>Vehículo Financiado</strong> con VWFS) por 500€ (CUPRA Born 400€)</h5>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="row">
                        <div class="col-md-12">
                            <ul>
                                <li> Mantenimiento durante 5 años o 80.000km (lo que antes ocurra). Operaciones incluidas según plan de mantenimiento. Operaciones adicionales no cubiertas.</li>
                                <li>Garantía de fabricante durante 3 años adicionales a los 2 iniciales o 100.000km (lo que antes ocurra). Sin intermediarios.</li>
                                <li>Servicio Concierge durante 5 años: asistencia en compras y reservas de eventos, restaurantes, billetes de transporte, vehículos de alquiler.</li>
                                <li>Servicio de Defensa Legal durante 5 años: Acceso a la red de abogados CUPRA para la gestión de multas y reclamaciones, asesoramiento legal y defensa penal.</li>
                            </ul>

                        </div>

                    </div>
                </ng-template>
            </ngb-panel>
            <ngb-panel>
                <ng-template ngbPanelTitle>
                    <h5>CUPRA CARE (<strong>Vehículo NO Financiado</strong> con VWFS) por 500€ (CUPRA Born 400€)</h5>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="col-md-12">
                        <ul>
                            <li>Mantenimiento durante 5 años o 80.000km (lo que antes ocurra). Operaciones incluidas según plan de mantenimiento. Operaciones adicionales no cubiertas.</li>
                            <li>Servicio Concierge durante 5 años: asistencia en compras y reservas de eventos, restaurantes, billetes de transporte, vehículos de alquiler.</li>
                            <li>Servicio de Defensa Legal durante 5 años: Acceso a la red de abogados CUPRA para la gestión de multas y reclamaciones, asesoramiento legal y defensa penal.</li>
                        </ul>
                    </div>
                </ng-template>
            </ngb-panel>
        </ngb-accordion>
    </div>
    <!-- <div class="modal-footer">
            <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
        </div> -->
</ng-template>